module.exports = __webpack_public_path__ + "img/relacao_equipe.95911088.svg";